import { useQuery } from '@tcs/common/hooks/useQuery';
import { AccountProfile } from '@tcs/client-portal-api/src/types/AccountProfile';

interface useAccountProfileProps {
  loading: boolean;
  data?: AccountProfile;
}

export const useAccountProfile = (
  accountNumber?: string
): useAccountProfileProps => {
  const { data, isLoading: loading } = useQuery<AccountProfile, Error>(
    `/accounts/${accountNumber}/profile`,
    {
      refetchOnMount: false,
      enabled: accountNumber !== undefined,
    }
  );
  return {
    loading,
    data,
  };
};

export default useAccountProfile;
